// extracted by mini-css-extract-plugin
export default {"warning-text":"style__warning-text--VBTdR","warningText":"style__warning-text--VBTdR"};